// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000"};